import { SMART_SEARCH_KEY } from '../constants/smartSearchKey';
import { ColumnsSetting } from '../types/Api';

/**
 * Filters out technical columns from the provided column settings array.
 *
 * This function removes columns with keys that match specific technical identifiers,
 * such as `SMART_SEARCH_KEY` and `'eag-col-actions'`, from the given array of column settings.
 *
 * @param columnSettings - An array of column settings to be filtered.
 * @returns A new array of column settings excluding the technical columns.
 */
export const filterTechnicalArray = (columnSettings: ColumnsSetting[]): ColumnsSetting[] => columnSettings?.filter(columnSetting => columnSetting.columnKey !== SMART_SEARCH_KEY && columnSetting.columnKey !== 'eag-col-actions');